import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";

// Define a type for the request argument
type CancelFinalizedPayslipsRequest = {
  request: number;
  documentNamePlural: string;
};

const CancelFinalizedPayslipsApiService = async (
  cancelRequest: CancelFinalizedPayslipsRequest
): Promise<boolean> => {
  const uri = `/document_processing_jobs/${
    cancelRequest.request
  }/revoke_employee_${cancelRequest.documentNamePlural.toLowerCase()}/`;
  const { data } = await axios.patch(uri);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useCancelFinalizedPayslipsApiService = () =>
  useMutation<boolean, AxiosError, CancelFinalizedPayslipsRequest>(
    "document_processing_jobs",
    CancelFinalizedPayslipsApiService
  );

export default useCancelFinalizedPayslipsApiService;
